import type { AppMessages } from '../../types';

export const app: AppMessages = {
  common: {
    loading: 'Загрузка...',
    saving: 'Сохранение...',
    save: 'Сохранить',
    back: 'Назад',
    error: 'Ошибка',
    notSet: 'Не задано',
    user: 'Пользователь',
    system: 'Система',
    copied: 'Скопировано!',
    copy: 'Копировать',
    cancel: 'Отмена',
    creating: 'Создание...',
    processing: 'Обработка...',
    you: 'Вы',
    stars: 'Stars',
    seeAll: 'Показать все',
    filter: 'Фильтр',
    amount: 'Сумма',
    date: 'Дата',
    details: 'Подробности',
    mustBeLoggedIn: 'Необходимо войти в систему',
    daysShort: 'д',
    hoursShort: 'ч',
    minutesShort: 'мин',
    justNow: 'Только что',
    noTitle: 'Без названия',
    payment: 'платёж',
    payments: 'платежи',
  },
  layout: {
    dashboard: 'Панель управления',
    invoices: 'Счета',
    ledger: 'Журнал',
    withdraws: 'Выводы',
    redirects: 'Перенаправления',
    settings: 'Настройки',
    admin: 'Админ',
    profile: 'Профиль',
    logout: 'Выйти',
    tonConfigured: 'TON настроен',
    configureTon: 'Настроить TON',
    tonNotConfigured: 'Адрес TON не настроен',
    active: 'Активен',
    walletConnect: 'Подключить кошелёк',
    walletTitle: 'Подключите ваш TON-кошелёк',
    walletSubtitle: 'Введите адрес TON, на который будут приходить ваши выводы.',
    walletConnectedTitle: 'Кошелёк подключён',
    walletConnectedSubtitle: 'Ваши выводы будут отправляться на этот адрес.',
    walletCurrentAddress: 'Подключённый адрес',
    walletAddressLabel: 'Адрес TON',
    walletHint: 'Принимается формат user-friendly (EQ… / UQ…) или raw (0:…).',
    walletInvalidAddress: 'Некорректный адрес TON',
    walletUpdate: 'Обновить адрес',
    walletChangeAddress: 'Изменить адрес',
    walletDisconnect: 'Отключить',
    walletDisconnectConfirmTitle: 'Отключить кошелёк?',
    walletDisconnectConfirmBody: 'Вы не сможете запрашивать выводы, пока не подключите новый адрес.',
    walletSaved: 'Кошелёк успешно подключён',
    walletDisconnected: 'Кошелёк отключён',
    newPaymentLink: 'Новая ссылка на оплату',
    openBot: 'Telegram-бот',
    helpCenter: 'Центр помощи',
  },
  login: {
    seoTitle: 'Вход | Платформа оплаты Telegram Stars',
    seoDescription: 'Войдите в свой аккаунт Telegram Stars Payment Platform',
    signIn: 'Вход',
    signUp: 'Регистрация',
    email: 'Эл. почта',
    password: 'Пароль',
    displayNameOptional: 'Отображаемое имя (необязательно)',
    displayNamePlaceholder: 'Ваше имя',
    emailPlaceholder: 'your@email.com',
    signInButton: 'Войти',
    signUpButton: 'Зарегистрироваться',
    signInWithGoogle: 'Войти через Google',
    or: 'ИЛИ',
    welcome: 'Добро пожаловать',
    subtitle: 'Войдите или создайте аккаунт, чтобы начать',
    minPasswordHint: 'Минимум 6 символов',
    tipTelegram: '💡 Совет: вы можете привязать аккаунт Telegram в настройках после регистрации',
    continueWithTelegram: 'Продолжить через Telegram',
    telegramAuthError: 'Не удалось войти через Telegram. Попробуйте ещё раз.',
    featureInstant: 'Мгновенное создание аккаунта',
    featureManage: 'Управляйте платежами Telegram Stars',
    featureWithdraw: 'Выводите средства в TON',
    emailRequired: 'Введите адрес эл. почты',
    emailInvalid: 'Неверный формат эл. почты',
    passwordRequired: 'Введите пароль',
    passwordRequiredSignup: 'Введите пароль',
    passwordMinLength: 'Пароль должен содержать не менее 6 символов',
    genericError: 'Произошла ошибка',
    recaptchaFailed: 'Ошибка проверки reCAPTCHA. Попробуйте снова.',
    invalidCredentials: 'Неверный адрес эл. почты или пароль. Если у вас ещё нет аккаунта, создайте его на вкладке «Регистрация».',
    wrongPassword: 'Неверный пароль. Проверьте пароль.',
    tooManyAttempts: 'Слишком много попыток. Попробуйте позже.',
    accountDisabled: 'Этот аккаунт отключён. Обратитесь в поддержку.',
    authNotEnabled: 'Аутентификация по эл. почте/паролю не включена. Проверьте конфигурацию Firebase.',
    emailInUse: 'Этот адрес эл. почты уже используется. Войдите с этим адресом.',
    googleAuthError: 'Ошибка при аутентификации через Google',
    popupClosed: 'Всплывающее окно было закрыто. Попробуйте снова.',
    popupBlocked: 'Всплывающее окно заблокировано. Разрешите всплывающие окна и попробуйте снова.',
    popupCancelled: 'Одновременно разрешён только один запрос всплывающего окна.',
  },
  dashboard: {
    loading: 'Загрузка панели...',
    overallSummary: 'Общая сводка',
    lastMonth: 'Прошлый месяц',
    lastWeek: 'Прошлая неделя',
    lastYear: 'Прошлый год',
    balance: 'Баланс',
    available: 'Доступно',
    totalEarned: 'Всего заработано',
    fromLastMonth: 'по сравнению с прошлым месяцем',
    recentPayments: 'Последние платежи',
    last7days: 'Последние 7 дней',
    last30days: 'Последние 30 дней',
    quickActions: 'Быстрые действия',
    createLink: 'Создать ссылку',
    createLinkDesc: 'Сгенерировать новую платёжную ссылку',
    withdraw: 'Вывести',
    withdrawDesc: 'Вывести Stars в TON',
    invoices: 'Счета',
    invoicesDesc: 'Просмотр истории платежей',
    ledger: 'Журнал',
    ledgerDesc: 'Просмотр всех транзакций',
    recentActivity: 'Последняя активность',
    noRecentActivity: 'Нет недавней активности',
    mostRecent: 'Последние',
    noRecentInvoices: 'Нет недавних счетов',
    allInvoices: 'Все счета',
    paymentReceived: 'Платёж получен: {title}',
    withdrawalRequested: 'Запрос на вывод: {amount} {suffix}',
    transaction: 'Транзакция: {amount} {suffix}',
    invoiceLabel: 'Счёт #{id}',
    failedLoadBalance: 'Не удалось загрузить баланс',
    chartAmount: 'Сумма',
  },
  invoices: {
    loading: 'Загрузка...',
    allInvoices: 'Все счета',
    paid: 'Оплаченные',
    sent: 'Отправленные',
    created: 'Созданные',
    expired: 'Истёкшие',
    filter: 'Фильтр',
    createInvoice: '+ Создать счёт',
    noInvoices: 'Счета не найдены',
    relatedTo: 'Связано с:',
    paymentMode: 'Оплата {mode}',
    copyLink: 'Копировать ссылку',
    copyLinkTitle: 'Копировать ссылку на счёт',
    linkNotAvailable: 'Ссылка на счёт недоступна',
    linkCopied: 'Ссылка на счёт скопирована в буфер обмена!',
    copyFailed: 'Не удалось скопировать ссылку',
    failedLoad: 'Не удалось загрузить счета',
    statusPaid: 'оплачен',
    statusSent: 'отправлен',
    statusCreated: 'создан',
    statusExpired: 'истёк',
    typeSingleUse: 'одноразовый',
    typeRecurring: 'повторяющийся',
  },
  createInvoice: {
    back: 'Назад',
    title: 'Создать платёжную ссылку',
    subtitle: 'Создайте новую платёжную ссылку за секунды',
    successTitle: 'Платёжная ссылка создана!',
    successSubtitle: 'Ваша платёжная ссылка готова к отправке',
    paymentLink: 'Платёжная ссылка:',
    integrationTitle: 'Интегрируйте эту ссылку на ваш сайт',
    integrationDesc: 'Наш Telegram-бот проведёт вас шаг за шагом (API, HTML-кнопка, перенаправления).',
    openTutorial: 'Открыть руководство',
    testLink: 'Проверить ссылку',
    viewInvoices: 'Мои счета',
    createNew: 'Создать новую ссылку',
    shareTelegram: 'Поделиться в Telegram',
    paymentMode: 'Способ оплаты',
    modeStars: 'Stars',
    modeEur: 'EUR (€)',
    modeUsd: 'USD ($)',
    amountInteger: 'Сумма (целое число)',
    amountDecimal: 'Сумма (десятичная)',
    amountRequired: 'Введите сумму',
    amountIntegerError: 'Сумма должна быть целым числом больше 0',
    amountNoDecimals: 'Сумма в Stars должна быть целым числом (без десятичных)',
    amountMustBeInteger: 'Сумма в Stars должна быть целым числом',
    amountGreaterThanZero: 'Сумма должна быть больше 0',
    titleOptional: 'Название (необязательно)',
    titlePlaceholder: 'Название платежа (напр.: Оплата услуг)',
    descriptionOptional: 'Описание (необязательно)',
    descriptionPlaceholder: 'Подробное описание платежа...',
    singleUse: 'Одноразовая ссылка',
    singleUseTooltip: 'Если включено, ссылку можно использовать только один раз. После оплаты она станет недействительной.',
    createLink: 'Создать ссылку',
    cancel: 'Отмена',
    invalidAmount: 'Неверная сумма',
    starsMustBeInteger: 'Сумма для Stars должна быть целым числом',
    createError: 'Ошибка при создании счёта',
  },
  ledger: {
    title: 'Журнал',
    typeColumn: 'Тип',
    description: 'Полная история всех ваших транзакций',
    loading: 'Загрузка...',
    noEntries: 'Транзакций пока нет.',
    typePayment: 'Платёж',
    typeFee: 'Комиссия',
    typeNetPayment: 'Чистый платёж',
    typeWithdrawal: 'Вывод',
    typeAdjustment: 'Корректировка',
    amountStars: 'Сумма (Stars)',
    invoiceDetail: 'Счёт: {title} ({amount} Stars)',
    paidBy: 'Оплачено: {payer}',
    payerId: '(ID: {id})',
    withdrawDetail: 'Вывод: {amount} Stars (Статус: {status})',
    failedLoad: 'Не удалось загрузить журнал',
  },
  withdraws: {
    title: 'Мои запросы на вывод',
    newRequest: '+ Новый запрос',
    totalLedger: 'Итого по журналу',
    available: 'Доступно',
    pendingWithdrawals: 'Ожидающие выводы',
    hold21days: 'Удержание 21 день',
    payoutNote: 'Выплаты обрабатываются вручную администратором. При выводе взимается комиссия 3%.',
    forecastTitle: 'Прогноз выводов',
    loadingForecast: 'Загрузка прогноза...',
    noForecast: 'Нет предстоящих дат вывода',
    paymentsCount: '({count} платежей)',
    noRequests: 'Запросов на вывод пока нет.',
    createFirst: 'Создайте первый запрос',
    amount: 'Сумма:',
    destination: 'Назначение:',
    processedOn: 'Обработано:',
    externalRef: 'Внешняя ссылка:',
    errorLabel: 'Ошибка:',
    rejectionReason: 'Причина отклонения:',
    failedLoad: 'Не удалось загрузить выводы',
    loading: 'Загрузка...',
  },
  createWithdraw: {
    title: 'Запросить вывод',
    balanceSource: 'Баланс (источник: журнал backend)',
    available: 'Доступно: {amount} Stars',
    pending: 'Ожидающие выводы: {amount} Stars',
    waiting: 'Удержание 21 день: {amount} Stars',
    minAndFee: 'Минимальный вывод: {min} Stars · Комиссия платформы: 3% при выплате (ручная обработка)',
    amountLabel: 'Сумма (Stars)',
    minPlaceholder: 'Минимум: {min}',
    feeHint: 'Брутто: {gross} Stars · Комиссия (3%): {fee} Stars · Вы получите: {net} Stars',
    useRegistered: 'Использовать мой зарегистрированный адрес TON',
    registeredAddress: 'Зарегистрированный адрес:',
    tonDestination: 'Адрес назначения TON',
    tonPlaceholder: 'EQAbc123...',
    tonFormatHint: 'Формат: EQ... или 0:... (base64 или hex)',
    createRequest: 'Создать запрос',
    cancel: 'Отмена',
    creating: 'Создание...',
    insufficientBalance: '⚠️ Недостаточно средств для вывода (минимум: {min} Stars)',
    amountMustBeInteger: 'Сумма должна быть положительным целым числом',
    createError: 'Ошибка при создании запроса на вывод',
  },
  redirects: {
    title: 'Ссылки перенаправления',
    description: 'Создавайте короткие ссылки, перенаправляющие на выбранный URL. Ссылка /r/ваш-slug направит посетителей на настроенный URL.',
    newRedirect: 'Новое перенаправление',
    clicks: 'клики',
    unique: 'уникальные',
    links: 'ссылки',
    modalTitle: 'Новое перенаправление',
    slugLabel: 'Slug (идентификатор ссылки)',
    slugRequired: 'Обязательное поле',
    slugPattern: 'Только буквы, цифры, дефисы и подчёркивания',
    slugMax: 'Макс. 64 символа',
    slugReserved: 'Этот slug зарезервирован. Выберите другой.',
    slugPlaceholder: 'напр.: мой-сайт',
    urlLabel: 'URL назначения',
    urlInvalid: 'Неверный URL',
    urlHttpOnly: 'Принимаются только URL http и https.',
    urlTooLong: 'URL слишком длинный (макс. 2048 символов).',
    urlPlaceholder: 'https://example.com/page',
    createButton: 'Создать перенаправление',
    loading: 'Загрузка…',
    empty: 'Нет перенаправлений. Нажмите «Новое перенаправление», чтобы создать.',
    copyLink: 'Копировать ссылку',
    linkCopied: 'Ссылка скопирована',
    deleteTitle: 'Удалить это перенаправление?',
    yes: 'Да',
    no: 'Нет',
    delete: 'Удалить',
    totalClicks: 'Всего кликов',
    uniqueClicks: 'Уникальные клики',
    avgClicks: 'Средн. кликов/посетитель',
    loadError: 'Ошибка загрузки перенаправлений',
    createSuccess: 'Ссылка перенаправления создана',
    createError: 'Ошибка создания перенаправления',
    deleteSuccess: 'Перенаправление удалено',
    deleteError: 'Ошибка удаления перенаправления',
  },
  adminWithdraws: {
    title: 'Администрирование - Запросы на вывод',
    filterByStatus: 'Фильтр по статусу:',
    all: 'Все',
    noRequests: 'Нет запросов для этого статуса.',
    agent: 'Агент:',
    amount: 'Сумма:',
    destination: 'Назначение:',
    processedOn: 'Обработано:',
    externalRef: 'Внеш. ссылка:',
    errorLabel: 'Ошибка:',
    reason: 'Причина:',
    approve: '✓ Одобрить',
    reject: '✗ Отклонить',
    markPaid: '✓ Отметить оплаченным',
    markFailed: '✗ Отметить неудачным',
    approveConfirm: 'Одобрить этот запрос на вывод?',
    rejectPrompt: 'Причина отклонения:',
    markPaidPrompt: 'Внешняя ссылка на выплату (обязательно — хеш tx TON, банк. ссылка и т.д.):',
    markPaidRequired: 'externalRef обязателен для подтверждения ручной выплаты.',
    markFailedPrompt: 'Сообщение об ошибке:',
    approveError: 'Ошибка одобрения вывода',
    rejectError: 'Ошибка отклонения вывода',
    updateError: 'Ошибка обновления',
    failedLoad: 'Не удалось загрузить выводы',
    notAuthenticated: 'Не аутентифицирован',
    operationFailed: 'Операция не выполнена',
    loading: 'Загрузка...',
  },
  redirectResolve: {
    missingSlug: 'Отсутствует slug',
    invalidLink: 'Неверная ссылка',
    notFound: 'Ссылка не найдена',
    notFoundTitle: 'Ссылка не найдена',
    redirecting: 'Перенаправление...',
    redirectTitle: 'Перенаправление',
  },
  errorBoundary: {
    title: 'Произошла ошибка',
    subtitle: 'Извините, что-то пошло не так. Попробуйте снова.',
    goHome: 'На главную',
    reload: 'Перезагрузить страницу',
    devDetails: 'Детали ошибки (только dev):',
  },
};

export const settingsApp = {
  eyebrow: 'НАСТРОЙКИ',
  profile: 'Профиль',
  email: 'Эл. почта',
  telegramId: 'ID Telegram',
  notLinked: 'Не привязан',
  linking: 'Привязка...',
  linkTelegram: 'Привязать аккаунт Telegram',
  openFromTelegram: '⚠️ Откройте эту страницу из Telegram, чтобы привязать аккаунт',
  displayName: 'Отображаемое имя',
  displayNameHint: 'Отображаемое имя задаётся при создании аккаунта',
  withdrawal: 'Вывод',
  tonAddress: 'Адрес назначения TON',
  tonAddressPlaceholder: 'EQAbc123... или 0:...',
  tonAddressHint: 'Этот адрес будет использоваться по умолчанию для выводов',
  tonUpdated: 'Адрес TON успешно обновлён',
  about: 'О приложении',
  commission: 'Комиссия платформы:',
  commissionValue: '3% с каждого платежа',
  minWithdrawal: 'Минимальный вывод:',
  minWithdrawalValue: '100 Stars',
  starsCurrency: 'Валюта Stars:',
  starsCurrencyValue: 'XTR',
  telegramWebAppNotAvailable: 'Telegram WebApp недоступен. Откройте эту страницу из Telegram.',
  telegramUserDataNotAvailable: 'Данные пользователя Telegram недоступны.',
  telegramLinked: 'Аккаунт Telegram успешно привязан!',
  linkTelegramError: 'Ошибка привязки аккаунта Telegram',
  updateError: 'Ошибка обновления',
  mustBeLoggedIn: 'Необходимо войти в систему',
};
